import type { FC } from "react"
import type { CommentResponse } from "@/types/domain"
import CommentItem from "./CommentItem"

type CommentListProps = {
  comments: CommentResponse[]
  onReply: (comment: CommentResponse) => void
  loading?: boolean
}

const CommentList: FC<CommentListProps> = ({ comments, onReply, loading }) => {
  if (comments.length === 0 && !loading) {
    return (
      <div className="comment-empty">
        첫 댓글을 남겨주세요.
      </div>
    )
  }

  return (
    <div className="comment-list-container">
      {comments.map(comment => (
        <CommentItem key={comment.id} comment={comment} onReply={onReply} />
      ))}
      
      {loading && (
        <div className="comment-loading">
           댓글 불러오는 중...
        </div>
      )}
    </div>
  )
}

export default CommentList
